module.exports = __webpack_public_path__ + "1bb805446b880e7e63cae7ab00433f15.svg";